import { useState } from "react";

import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

import ExtendButton from "../../../common/components/live-view/MaximizeButton";
import HLSStreamPlayer from "../../data-hub/components/liveview/components/cameraView/HLSStreamPlayer";

interface LiveViewDialogProps {
  onClose: () => void;
}

const LiveViewDialog = ({ onClose }: LiveViewDialogProps) => {
  const [videoLoading, setVideoLoading] = useState(false);

  return (
    <Dialog
      PaperProps={{
        sx: {
          margin: 0,
          maxWidth: "100%",
          maxHeight: "100%",
          width: "100%",
          height: "100%",
          borderRadius: 0,
        },
      }}
      fullWidth
      open={true}
      onClose={onClose}
    >
      <Box sx={{ position: "absolute", zIndex: 3, right: 8, top: 8 }}>
        <ExtendButton
          hideStartIcon
          title="Close"
          variant="contained"
          changeExpandedMode={onClose}
        />
      </Box>
      <DialogContent
        sx={{
          padding: 0,
          margin: "0 auto",
          overflow: "hidden",
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          borderRadius: 0,
        }}
      >
        <HLSStreamPlayer
          videoLoading={videoLoading}
          setVideoLoading={setVideoLoading}
        />
      </DialogContent>
    </Dialog>
  );
};

export default LiveViewDialog;
